import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { Template } from 'devextreme-react/core/template';
import AntConfig from '../utils/AntConfig';
import AntTime from '../utils/AntTime';

import AntLocalization from '../utils/AntLocalization';
import AntCondition from '../utils/AntCondition';
import AntArray from '../utils/AntArray';
import { AntGlobal, AntSession } from '../utils/AntContext';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    const location = useLocation();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const tableName = props.table ? props.table : props.API ? props.API.entityName : '';

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const [shouldRender, setShouldRender] = useState(1);

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const isRender = useMemo(() => shouldRender + (props.shouldRender ? props.shouldRender : 1), [props.shouldRender, shouldRender]);

    const [searchText, setSearchText] = React.useState(null);
    const searchTextFocused = useRef(false);
    const searchTextComp = useRef();
    const searchTextTimeOut = useRef();

    const showScanBarcode = props.showScanBarcode !== undefined ? AntCondition.isValid(null, props.showScanBarcode) : false;

    const barcodeFocusing = useRef(false);
    const [showScanBarcodeBar, setShowScanBarcodeBar] = React.useState(false);
    const [scanBarcodeValue, setScanBarcodeValue] = React.useState('');
    const scanBarcodeComp = useRef();
    const searchBoxComp = useRef();

    const [mainItems, setMainItems] = useState([]);

    const onSearchText = useCallback((e) => {
        setSearchText(e.value);
    }, []);

    const switchBarcodeButton = useCallback(() => {
        let currentValue = Boolean(showScanBarcodeBar);
        let newValue = !currentValue;

        setShowScanBarcodeBar(newValue);
        if (currentValue) barcodeFocusing.current = false;

        if (props.onScanBarcodeModeChanged) props.onScanBarcodeModeChanged(newValue);
    }, [props.onScanBarcodeModeChanged, showScanBarcodeBar]);

    const onScanBarcode = useCallback(
        (e) => {
            barcodeFocusing.current = true;
            if (e.component) {
                scanBarcodeComp.current = e.component;
                // setTimeout(
                //     (e) => {
                //         e.component.focus();
                //     },
                //     300,
                //     e
                // );
            }

            if (e.value) {
                if (props.onScanBarcode)
                    props.onScanBarcode(e.value, (isSucceed) => {
                        if (isSucceed) {
                            setScanBarcodeValue('');
                            if (e.component) e.component.instance().reset('');
                        }
                    });
            }
        },
        [props.onScanBarcode]
    );

    const onScanBarcodeReady = useCallback(
        (args) => {
            scanBarcodeComp.current = args.component;

            var autoFocus = props.autoFocusSearchBarcode !== undefined ? props.autoFocusSearchBarcode : true;

            // autoFocus = Boolean(barcodeFocusing.current);

            if (Boolean(showScanBarcode && showScanBarcodeBar)) {
                args.component.focus();
                setTimeout(() => {
                    args.component.focus();
                }, 200);
            }
        },
        [props.autoFocusSearchBarcode, showScanBarcode, showScanBarcodeBar]
    );

    const onSearchBoxReady = useCallback((args) => {
        searchBoxComp.current = args.component;
    }, []);

    const focusSearchBox = useCallback(() => {
        if (searchBoxComp.current) searchBoxComp.current.focus();
    }, []);

    const initMainItems = useCallback(() => {
        var items = [];

        items.push({
            visible: Boolean(showScanBarcode && showScanBarcodeBar),
            name: 'scanBarcode',
            cssClass: 'ant-pos-search-box ant-pos-barcode-scanner',
            stylingMode: 'outlined',
            location: 'center',
            locateInMenu: 'never',
            widget: 'dxTextBox',
            showText: 'inMenu',
            options: {
                buttons: [
                    {
                        name: 'searchIcon',
                        location: 'before',
                        options: {
                            icon: 'fa fa-barcode',
                            type: 'normal',
                            stylingMode: 'text',
                            onClick: switchBarcodeButton
                        }
                    },
                    'clear'
                ],
                showClearButton: true,
                mode: 'search',
                placeholder: AntLocalization.translateText({ vi: 'Quét mã vạch...', en: 'Scan Barcode...', fr: 'Scanner le code...', es: 'Escanear código...', id: 'Pindai Barcode...', ja: 'バーコードをスキャン...', zh: '扫描条形码...', ko: '바코드 스캔...', hi: 'बारकोड स्कैन करें...', ar: 'مسح الباركود...' }),
                height: 40,
                width: window.innerWidth * 0.3,
                value: scanBarcodeValue,
                valueChangeEvent: 'change',
                onValueChanged: onScanBarcode,
                onFocusIn: (e) => {
                    barcodeFocusing.current = true;

                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                    if (inputEl) {
                        inputEl.selectionStart = 0;
                        inputEl.selectionEnd = inputEl.value.length;
                    }
                    // setScanBarcodeValue('');
                    // if (props.onStartScanBarcode) props.onStartScanBarcode(e);
                },
                onFocusOut: (e) => {
                    if (Boolean(showScanBarcode && showScanBarcodeBar)) {
                        e.component.focus();
                    } else setScanBarcodeValue('');
                    // if (props.onEndScanBarcode) props.onEndScanBarcode(e);
                },
                onContentReady: onScanBarcodeReady
            }
        });

        if (props.showSearchBox !== false)
            items.push({
                visible: !Boolean(showScanBarcode && showScanBarcodeBar),
                name: 'searchBox',
                cssClass: 'ant-pos-search-box',
                stylingMode: 'outlined',
                location: 'center',
                locateInMenu: 'never',
                widget: 'dxTextBox',
                showText: 'inMenu',
                options: {
                    stylingMode: 'outlined',
                    buttons: [
                        {
                            name: 'searchIcon',
                            location: 'before',
                            options: {
                                icon: 'fa fa-search',
                                type: 'normal',
                                stylingMode: 'text'
                                // disabled: true,
                                // onClick: switchBarcodeButton
                            }
                        },
                        'clear'
                    ],
                    showClearButton: true,
                    mode: 'search',
                    placeholder: AntLocalization.translateText({ vi: 'Tìm kiếm...', en: 'Search...', fr: 'Rechercher...', es: 'Buscar...', id: 'Cari...', ja: '検索...', zh: '搜索...', ko: '검색...', hi: 'खोजें...', ar: 'بحث...' }),
                    height: 40,
                    width: window.innerWidth * 0.3,
                    valueChangeEvent: 'keyup',

                    onValueChanged: onSearchText,
                    onClick: props.onRefreshClick,

                    onFocusIn: (e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                    },
                    onContentReady: onSearchBoxReady
                }
            });

        items.push({
            name: 'showBarcode',
            location: 'center',
            widget: 'dxButton',
            visible: Boolean(showScanBarcode && !showScanBarcodeBar),
            locateInMenu: 'never',
            options: {
                icon: 'fa fa-barcode',
                stylingMode: 'text',
                focusStateEnabled: props.focusStateEnabled,
                onClick: switchBarcodeButton
            }
        });

        if (props.showRefresh !== false)
            items.push({
                name: 'actionRefresh',
                location: items.length <= 0 ? 'before' : 'center',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                waiting: true,
                options: {
                    icon: 'refresh',
                    text: AntLocalization.translateText({ vi: 'Làm mới', en: 'Refresh', fr: 'Actualiser', es: 'Actualizar', id: 'Segarkan', ja: '更新', zh: '刷新', ko: '새로고침', hi: 'ताज़ा करें', ar: 'تحديث' }),
                    stylingMode: 'text',
                    onClick: props.onRefreshClick
                }
            });
        items = items.filter((item) => Boolean(item));

        // for (let i = 0; i < items.length; i++) {
        //     let item = items[i];
        //     if (item.waiting) item.template = 'renderButton';
        // }

        return items;
    }, [
        onSearchText,
        props.focusStateEnabled,
        props.showSearchBox,
        props.showRefresh,
        scanBarcodeValue,
        onScanBarcode,
        switchBarcodeButton,
        onScanBarcodeReady,
        showScanBarcode,
        showScanBarcodeBar
    ]);

    useEffect(() => {
        setMainItems(initMainItems());
        forceRender();
    }, [initMainItems]);

    useEffect(() => {
        if (props.onSearchText && searchText !== null) {
            // if (props.cacheData) props.onSearchText(searchText);
            // else {
            if (searchTextTimeOut.current) clearTimeout(searchTextTimeOut.current);
            searchTextTimeOut.current = setTimeout(
                (value) => {
                    props.onSearchText(value);
                },
                props.cacheData ? 200 : 1000,
                searchText
            );
            // }
        }
    }, [searchText]);

    useImperativeHandle(ref, () => ({
        focusSearchBox: focusSearchBox
    }));

    return (
        <React.Fragment>
            {isRender && (
                <div display={{ width: '100%', display: 'flex' }}>
                    <Toolbar className="ant-pos-search-bar" items={mainItems}>
                        {/* <Template name={'renderSearchBox'} render={renderSearchBox} /> */}
                    </Toolbar>
                </div>
            )}
        </React.Fragment>
    );
});
